<div class="card w-100 box-shadow" *ngIf="!spinner">
    <div class="card-header bg-primary">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <h4 class="heading text-2xl font-bold ff-robo text-white my-2 my-md-0 ms-md-4">
                Questionnaire
            </h4>
            <div class="d-flex gap-2 me-md-4" *ngIf="!showForm && activeTab !== 'mentor'">
                <button (click)="downloadPdf()" class="btn btn-light btn-sm">
                    <i class="fa fa-download"></i>&nbsp;<b>Download PDF</b>
                </button>
                <button *ngIf="!showInsName" (click)="copyLinkToClipboard()" class="btn btn-light btn-sm">
                    <i class="fa fa-link" aria-hidden="true"></i>&nbsp;<b>Copy Link</b>
                </button>
            </div>
        </div>
    </div>

    <div class="card-body p-0" *ngIf="role === 'PORTAL_MENTOR' && !showForm">
        <ul class="nav nav-tabs custom-tabs px-4 pt-3 bg-light" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link" [class.active]="activeTab === 'student'" (click)="switchTab('student')"
                    type="button">
                    <b>Student Form</b>
                </button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link" [class.active]="activeTab === 'mentor'" (click)="switchTab('mentor')"
                    type="button">
                    <b>Mentor Form</b>
                </button>
            </li>
        </ul>
    </div>

    <div #pdfContent class="container mt-4 mb-5 questionnnarie-card" id="pdf-content" *ngIf="!showForm">
        <div id="pdf-inner-wrapper">
            <div class="qn-card shadow">
                <div class="card-header d-flex flex-column flex-md-row align-items-center position-relative">
                    <div class="position-absolute top-0 end-0 mt-2 me-3 fw-bold">{{questionnarieNumber}}</div>
                    <img src="assets/images/logo/NewLogo.png" alt="Logo" class="logo-img mb-2 mb-md-0 me-md-3">
                    <div class="text-center flex-grow-1">
                        <h4 class="mb-1 heading">INDIA READS - AN ELTAI PROJECT</h4>
                        <h3 class="mb-1 formHead">{{questionnarieTitle}}</h3>
                        <p class="mb-0">The survey is conducted to collect information related to one's habit of
                            reading.</p>
                    </div>
                    <img src="assets/images/logo/logo2.png" alt="Logo 2" class="logo-img mb-2 mb-md-0 me-md-3">
                </div>
                <p *ngIf="!showInsName" class="text-center Institution-name mt-3 hide-in-pdf">{{InsName}}</p>
                <div class="card-body">
                    <form [formGroup]="dynamicForm">
                        <div class="container">
                            <div class="row first-page">
                                <p class="text-center Institution-name show-only-in-pdf">{{InstituteName}}</p>

                                <div class="col-md-5 mb-3">
                                    <label for="name" class="form-label form-head">1. Name:</label>
                                </div>
                                <div class="col-md-7 mb-3">
                                    <input type="text" class="form-control" id="name" formControlName="name" />
                                    <div class="error-msg-area">
                                        <div *ngIf="dynamicForm.controls['name'].errors && (!dynamicForm.controls['name'].pristine || isDynamicFormSubmitted)"
                                            class="error-msg">
                                            <div *ngIf="dynamicForm.controls['name'].errors?.required"
                                                class="text-danger hide-in-pdf">
                                                Please enter the name
                                            </div>
                                            <div *ngIf="!dynamicForm.controls['name'].errors?.required && dynamicForm.controls['name'].errors?.whitespace"
                                                class="text-danger hide-in-pdf">
                                                Please enter the valid name
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <ng-container *ngIf="activeTab !== 'mentor'">
                                    <div class="col-md-5 mb-3">
                                        <label for="email" class="form-label form-head">2. Email ID:</label>
                                    </div>
                                    <div class="col-md-7 mb-3">
                                        <input type="email" class="form-control" id="email" formControlName="email">
                                        <div class="error-msg-area">
                                            <div *ngIf="dynamicForm.controls['email'].errors && (!dynamicForm.controls['email'].pristine || isDynamicFormSubmitted)"
                                                class="error-msg">
                                                <div *ngIf="dynamicForm.controls['email'].errors.required"
                                                    class="text-danger hide-in-pdf">
                                                    Please enter the email
                                                </div>
                                                <div *ngIf="dynamicForm.controls['email'].errors.email"
                                                    class="text-danger hide-in-pdf">
                                                    Please enter a valid email address
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="activeTab !== 'mentor'">
                                    <div class="col-md-5 mb-3">
                                        <label for="year" class="form-label form-head">3. Class/Standard/Year:</label>
                                    </div>
                                    <div class="col-md-7 mb-3">
                                        <input type="text" class="form-control" id="year" formControlName="year" />
                                    </div>
                                </ng-container>

                                <div class="col-md-5 mb-3">
                                    <label for="address" class="form-label form-head">
                                        {{ activeTab === 'mentor' ? '2. Institution Name:' : '4. Institutional Address:' }}
                                    </label>
                                </div>
                                <div class="col-md-7 mb-3">
                                    <input type="text" class="form-control" id="address" formControlName="address" />
                                </div>

                                <hr style="border-top: 3px dashed #999; background: none;"
                                    class="mt-3 hide-in-pdf page-break" />
                            </div>

                            <div formArrayName="dynamicFields" class="ms-0">
                                <div
                                    *ngFor="let group of getChunkedFields(); let groupIndex = index; trackBy: trackByGroup">
                                    <div class="row mb-3 keep-together"
                                        *ngFor="let field of group; let i = index; trackBy: trackByField"
                                        [formGroup]="field">
                                        <div class="col-md-5 d-flex align-items-center">
                                            <label class="mb-0 form-head d-flex justify-content-between">
                                                <span>{{ getGlobalIndex(groupIndex, i) }}.</span>
                                                <span>{{field.get('fieldName')?.value }}</span>
                                            </label>
                                        </div>
                                        <div class="col-md-7">
                                            <ng-container [ngSwitch]="field.get('fieldType')?.value">
                                                <input *ngSwitchCase="'text'" type="text" class="form-control"
                                                    formControlName="value" />
                                                <input *ngSwitchCase="'email'" type="email" class="form-control"
                                                    formControlName="value" />
                                                <input *ngSwitchCase="'number'" type="number" class="form-control"
                                                    formControlName="value" />
                                                <input *ngSwitchCase="'color'" type="color"
                                                    class="form-control form-control-color" formControlName="value" />
                                                <input *ngSwitchCase="'range'" type="range" class="form-control"
                                                    formControlName="value" />
                                                <textarea *ngSwitchCase="'textarea'" class="form-control" rows="2"
                                                    formControlName="value"></textarea>

                                                <div *ngSwitchCase="'select'" class="d-flex align-items-center gap-3">
                                                    <select class="form-control" formControlName="value"
                                                        (change)="onSelectChange($event, groupIndex, i)">
                                                        <option *ngFor="let opt of field.get('options')?.value"
                                                            [value]="opt">{{ opt }}</option>
                                                    </select>
                                                    <div *ngIf="field.get('showOtherInput')?.value" class="flex-grow-1">
                                                        <input type="text" class="form-control"
                                                            formControlName="otherText" />
                                                    </div>
                                                </div>

                                                <div *ngSwitchCase="'multiselect'"
                                                    class="d-flex align-items-center gap-3">
                                                    <ng-select class="form-control"
                                                        [items]="field.get('options')?.value" [multiple]="true"
                                                        [closeOnSelect]="false" [clearable]="true"
                                                        formControlName="value"
                                                        (change)="onMultiSelectChange($event, groupIndex, i)">
                                                    </ng-select>
                                                    <div *ngIf="field.get('showOtherInput')?.value" class="flex-grow-1">
                                                        <input type="text" class="form-control"
                                                            formControlName="otherText" />
                                                    </div>
                                                </div>

                                                <div *ngSwitchCase="'radio'"
                                                    class="d-flex align-items-center gap-3 flex-wrap">
                                                    <div *ngFor="let opt of field.get('options')?.value"
                                                        class="form-check mb-0">
                                                        <input type="radio" class="form-check-input" [value]="opt"
                                                            [id]="field.get('fieldName')?.value + '_' + opt"
                                                            formControlName="value"
                                                            (change)="onRadioChange(opt, groupIndex, i)" /> <label
                                                            class="form-check-label"
                                                            [for]="field.get('fieldName')?.value + '_' + opt">{{ opt
                                                            }}</label>
                                                    </div>
                                                    <div *ngIf="field.get('showOtherInput')?.value" class="flex-grow-1">
                                                        <input type="text" class="form-control"
                                                            formControlName="otherText" />
                                                    </div>
                                                </div>

                                                <div *ngSwitchCase="'checkbox'"
                                                    class="d-flex align-items-center gap-3 flex-wrap">
                                                    <div *ngFor="let opt of field.get('options')?.value"
                                                        class="form-check mb-0">
                                                        <input type="checkbox" class="form-check-input" [value]="opt"
                                                            [id]="field.get('fieldName')?.value + '_' + opt"
                                                            [checked]="field.get('value')?.value?.includes(opt)"
                                                            (change)="onCheckboxChange($event, groupIndex, i)" />
                                                        <label class="form-check-label"
                                                            [for]="field.get('fieldName')?.value + '_' + opt">{{ opt
                                                            }}</label>
                                                    </div>
                                                    <div *ngIf="field.get('showOtherInput')?.value" class="flex-grow-1">
                                                        <input type="text" class="form-control"
                                                            formControlName="otherText" />
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <hr style="border-top: 3px dashed #999; background: none;"
                                            class="mt-3 hide-in-pdf page-break" *ngIf="field.get('breakLine')?.value" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-grid gap-2 d-md-flex justify-content-md-end hide-in-pdf">
                            <button type="submit" class="btn btn-primary hide-in-pdf"
                                (click)="saveQuestionnarieForm()">Submit</button>
                        </div>
                    </form>
                </div>
                <div class="card-footer text-muted text-center keep-together">
                    <small>Prepared by: Dr. K. Elango, Chief Executive Chair, ELTAI, Professor and Head, Department of
                        English (Formerly), Anna University, Chennai.</small>
                </div>
            </div>
        </div>
    </div>
    <div class="text-center mt-5" *ngIf="showForm">
        <p class="notCreated text-center"> No questionnaire has been assigned to this institution.</p>
    </div>
</div>
<div class="loader" *ngIf="spinner"></div>